import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import AutoRecalls from './components/AutoRecalls';
const autoRecalls = (props, { t }) => (
    <Container>
        <AutoRecalls {...props} />
    </Container>
);

autoRecalls.propTypes = {
    t: PropTypes.func.isRequired,
};

export default withTranslation('common')(autoRecalls);
